export const POST_METRIC = 'post';
export const ENGAGEMENT_METRIC = 'engagement';
export const FOLLOWER_METRIC = 'follower';

export const SORTABLE_HEADERS = [
    'itemCount',
    'itemCountPerDay',
    'newFollowers',
    'postVolumeChange',
    'engagementsPerPost',
    'engagementRate',
];
